import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';

@Component({
  selector: 'email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {

  email: string;
  error = false;
  success = false;
  errorMsg: string;
  modalText = 'Loading...';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title,
    private authService: AuthService
  ) {
    this.email = this.router.getCurrentNavigation().extras.state.email;
  }

  ngOnInit(): void {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Email Confirmation');
  }

  resendEmail() {
    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Sending...';

    this.authService.resendActivationLink(this.email)
      .pipe(first())
      .subscribe(
        data => {
          if (!data.success) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

            this.error = true;
            this.errorMsg = data.error.msg;

            // Hides the error message after 5 seconds
            setTimeout(function() {
              this.error = false;
            }.bind(this), 5000);
            return;
          }

          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
          }, 500);

          this.success = true;
          setTimeout(function() {
            this.success = false;
          }.bind(this), 5000);
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
